// extracted by mini-css-extract-plugin
module.exports = {"modal":"index_modal__NajR7"};